export default __webpack_public_path__ + "static/media/blumeattempt-justlikeyou-06.b9df4184.jpg";